
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from "moment";

export const WorkAssignedDMCExportTableData = (props) => {
    const { ExcelData, name, searchName } = props
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />
            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={searchName == "Completed" ? 9 : 8} style={{ textAlign: 'center', fontSize: 16, border: '1px solid black' }}>{name}</th>
                </tr>

                {/* <tr><td></td></tr> */}

                <thead className="thead-dark" >
                    <tr style={{ backgroundColor: '#254462', color: "#fff" }}>
                        <th style={{ borderLeft: "1px solid black" }}>Sr.No.</th>
                        <th style={{ width: "7em", borderLeft: "1px solid white" }}>Assign Date</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Type</th>
                        <th style={{ borderLeft: "1px solid white" }}>Asset Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>Sector Name</th>
                        <th style={{ borderLeft: "1px solid white" }}>Area</th>
                        <th style={{ borderLeft: "1px solid white" }}>Work Name </th>
                        {
                            searchName == "Completed" ?
                                <>
                                    <th style={{ borderLeft: "1px solid white" }}>Completed Work Date</th>
                                </>
                                : ''
                        }
                        <th style={{ borderLeft: "1px solid white" }}>Officer Name</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item, i) => (
                            <tr style={{ textAlign: "center", border: '1px solid black' }}>
                                <td >{item.rowNum}</td>
                                <td>{item.workAssignDate ? moment(item.workAssignDate).format("DD-MM-YYYY") : '-'}</td>
                                <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                <td>{item.assetName ? item.assetName : '-'}</td>
                                <td>{item.sectorName ? item.sectorName : '-'}</td>
                                <td>{item.areaName ? item.areaName : '-'}</td>
                                <td>{item.workname ? item.workname : '-'}</td>
                                {
                                    searchName == "Completed" ?
                                        <>
                                            <td >{item.workDate ? moment(item.workDate).format("DD-MM-YYYY") : '-'}</td>
                                        </>
                                        : ''
                                }
                                <td>{item.assingBy ? item.assingBy : '-'}</td>

                            </tr>
                        )) : <tr>No data</tr>
                    }
                </tbody>
            </table>
        </div>
    )
}